import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-consumable-refund-bill-item.reducer';

export const PharmacyConsumableRefundBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyConsumableRefundBillItemEntity = useAppSelector(state => state.pharmacyConsumableRefundBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyConsumableRefundBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.detail.title">
            PharmacyConsumableRefundBillItem
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="refundPaid">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.refundPaid">Refund Paid</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.refundPaid}</dd>
          <dt>
            <span id="refundQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.refundQty">Refund Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.refundQty}</dd>
          <dt>
            <span id="soldQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.soldQty">Sold Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.soldQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.pharmacyStock ? pharmacyConsumableRefundBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.saleBillItem">Sale Bill Item</Translate>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.saleBillItem ? pharmacyConsumableRefundBillItemEntity.saleBillItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.refundBill">Refund Bill</Translate>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.refundBill ? pharmacyConsumableRefundBillItemEntity.refundBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.saleBill">Sale Bill</Translate>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.saleBill ? pharmacyConsumableRefundBillItemEntity.saleBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.returnBill ? pharmacyConsumableRefundBillItemEntity.returnBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.returnItem">Return Item</Translate>
          </dt>
          <dd>{pharmacyConsumableRefundBillItemEntity.returnItem ? pharmacyConsumableRefundBillItemEntity.returnItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-consumable-refund-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/pharmacy-consumable-refund-bill-item/${pharmacyConsumableRefundBillItemEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyConsumableRefundBillItemDetail;
